import { ApiSubscriptionTier } from "@incendium/api";

export interface SubscriptionPlanStyle {
  bg: string;
  border: string;
}

const planStyles: Record<ApiSubscriptionTier, SubscriptionPlanStyle> = {
  [ApiSubscriptionTier.SUBSCRIPTION_TIER_START]: {
    bg: "#fff",
    border: "#e2e6ff",
  },
  [ApiSubscriptionTier.SUBSCRIPTION_TIER_GROWTH]: {
    bg: "#f0f2ff",
    border: "#cbd3ff",
  },
  [ApiSubscriptionTier.SUBSCRIPTION_TIER_PRO]: {
    bg: "#e5e8fd",
    border: "#b2beff",
  },
  [ApiSubscriptionTier.SUBSCRIPTION_TIER_ENTERPRISE]: {
    bg: "#dde2ff",
    border: "#7e92ff",
  },
};

const fallbackStyle = planStyles[ApiSubscriptionTier.SUBSCRIPTION_TIER_START];

/** Visual style keyed by product tier enum (stable; not display name). */
export function getSubscriptionPlanStyle(
  tier?: ApiSubscriptionTier | null,
): SubscriptionPlanStyle {
  if (!tier) {
    return fallbackStyle;
  }
  return planStyles[tier] ?? fallbackStyle;
}
